var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useMemo, useState } from "react";
import { useGetModuleListQuery } from "@/store/api";
import { useGenerateDistinctColors } from "@/pages/administration/colorGenerator";
import { useAppSelector } from "@/hooks/store";
export var unencodeMultiEnum = function (multienumStringValue) {
    if (typeof multienumStringValue !== "string") {
        return [];
    }
    var values = [];
    var splitedStringValue = multienumStringValue === null || multienumStringValue === void 0 ? void 0 : multienumStringValue.split("^");
    splitedStringValue.forEach(function (s) {
        if (s !== "" && s !== "," && s !== " " && s !== undefined) {
            values.push(s);
        }
    });
    return values;
};
export var encodeMultiEnum = function (value) {
    if (Array.isArray(value)) {
        value = "^".concat(value.join("^^"), "^");
    }
    return "".concat(value);
};
/** <b>Composant en mode consultation/detail d'un champ de type multienum</b>*/
export default function MultiEnumFieldDetail(_a) {
    var fieldName = _a.fieldName, moduleName = _a.moduleName, record = _a.record, fieldMetadata = _a.fieldMetadata;
    var _b = useAppSelector(function (state) { return state.theme; }), colorBase = _b.colorBase, midColor = _b.midColor, endColor = _b.endColor;
    var value = useMemo(function () {
        if (!record) {
            return;
        }
        return record[fieldName || ""] || (fieldMetadata === null || fieldMetadata === void 0 ? void 0 : fieldMetadata.default);
    }, [fieldName, record]);
    var listValue = unencodeMultiEnum(value);
    //GENERATE COLOR BACKGROUND
    var moduleList = useGetModuleListQuery({
        table: moduleName,
        params: {
            count: false,
        },
    }).data;
    var _c = useState({}), colorMapping = _c[0], setColorMapping = _c[1];
    var numColors = "5";
    var shade = "700";
    var algo = "goldenRatio";
    var colors = useGenerateDistinctColors({
        numColors: numColors,
        shade: shade,
        colorBase: colorBase,
        algo: algo,
        endColor: endColor,
        midColor: midColor,
    }) || [];
    useEffect(function () {
        var _a, _b, _c, _d;
        if ((_a = moduleList === null || moduleList === void 0 ? void 0 : moduleList.data) === null || _a === void 0 ? void 0 : _a.records) {
            var values = (_b = moduleList === null || moduleList === void 0 ? void 0 : moduleList.data) === null || _b === void 0 ? void 0 : _b.records.map(function (record) { return record[fieldName]; });
            var filteredValues = Array.from(new Set((_d = (_c = values === null || values === void 0 ? void 0 : values.filter(function (value) { return value !== null; })) === null || _c === void 0 ? void 0 : _c.flatMap(function (value) { return value === null || value === void 0 ? void 0 : value.split("^"); })) === null || _d === void 0 ? void 0 : _d.filter(Boolean))).sort();
            var generatedColorMapping = filteredValues.reduce(function (acc, value, index) {
                acc[value] = colors[index % colors.length];
                return acc;
            }, {});
            setColorMapping(generatedColorMapping);
        }
    }, [moduleList, fieldName]);
    return (_jsx("span", __assign({ className: "flex items-center" }, { children: _jsx("ul", __assign({ className: "flex space-x-1" }, { children: listValue.map(function (list, index) {
                var backgroundColor = colorMapping[list] || "#e0e0e0"; // Couleur par défaut
                return (_jsx("li", __assign({ className: "border rounded", style: {
                        backgroundColor: backgroundColor,
                        color: "#fff",
                    } }, { children: _jsx("span", __assign({ className: "px-2" }, { children: list })) }), index));
            }) })) })));
}
